import { HttpClient } from './types';

export const createShippingService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/envios${url}`;

  return {
    getShippingOptions: <TShipping = any>(): Promise<TShipping[]> => {
      return httpClient.get<TShipping[]>(getEndpoint(''));
    },

    calculateShippingOptions: <TRequest = any, TShipping = any>(
      data: TRequest
    ): Promise<TShipping[]> => {
      return httpClient.post<TShipping[]>(getEndpoint(''), data);
    },
  };
};

